export default {
  prefix: process.env.VUE_APP_PATH_PREFIX,
  dateInputFormat: 'yyyy-MM-dd',
  dateTimeInputFormat: 'yyyy-MM-dd HH:mm:ss',
  dateOutputFormat: 'dd.MM.yyyy',
  dateTimeOutputFormat: 'dd.MM.yyyy HH:mm:ss',
  defaultTimezone: 'Europe/London',

  orderStatusList: ['Выполнен', 'В работе', 'Договор'],

  wardrobeTypeList: ['Корпусный шкаф', 'Угловой шкаф'],

  backendAddress: process.env.VUE_APP_BACKEND_API_URL,
  uploadsBase: process.env.VUE_APP_UPLOADS_URL,
  notificationsAuthAddress: process.env.VUE_APP_NOTIFICATIONS_AUTH_URL,
  wsHost: process.env.VUE_APP_WEBSOCKET_HOST,
  wsPort: process.env.VUE_APP_WEBSOCKET_PORT,
  wssPort: process.env.VUE_APP_WEBSOCKET_PORT_SECURE,
  wsKey: process.env.VUE_APP_WEBSOCKET_APP_KEY,

  flatpickr: {
    dateOutputFormat: 'd.m.Y',
    dateTimeInputFormat: 'Y-m-d H:i:S'
  },

  constructors: {
    wardrobeId: 2,
    doorsId: 1
  },

  websocketNotifications: {
    perPage: 20
  },

  float: {
    digits: 2,
    delimeter: ','
  },

  urls: {
    app: token =>
      `${process.env.VUE_APP_CONSTRUCTOR_URL}/iframe/${token}/index`,
    registration: [
      process.env.VUE_APP_LANDING_URL,
      process.env.VUE_APP_LANDING_REGISTRATION_PATH
    ].join('/'),
    agreement: [
      process.env.VUE_APP_LANDING_URL,
      process.env.VUE_APP_LANDING_AGREEMENT_PATH
    ].join('/'),
    policy: [
      process.env.VUE_APP_LANDING_URL,
      process.env.VUE_APP_LANDING_POLICY_PATH
    ].join('/'),
    offer: [
      process.env.VUE_APP_LANDING_URL,
      process.env.VUE_APP_LANDING_OFFER_PATH
    ].join('/')
  },

  supportEmail: process.env.VUE_APP_SUPPORT_EMAIL,

  api: {
    geonames: {
      user: 'nikkitakin',
      tzUrl: 'http://api.geonames.org/timezone'
    }
  }
};
